<template>
  <ul class="star-ul">
    <li v-for="(item,index) in starList" :key="item.labelId" :style="{background:activeKey===item.labelId?'#fff':''}"
        @click="handlerTab(item)">
      <p :class="activeKey===item.labelId?'activeClass':''">{{ item.parentName }}</p>
      <img v-if="activeKey===item.labelId" alt="" class="activeImg" src="@/assets/images/powderedMilk/naifenActive.png">
    </li>
  </ul>
</template>
<script>
export default {
  name: 'starLeft',
  data() {
    return {
      activeKey: 1,
    }
  },
  watch: {
    starList: {
      handler(newValue) {
        if (newValue.length) this.activeKey = newValue[0].labelId
      }
    }
  },
  props: {
    starList: {
      type: Array,
    }
  },
  methods: {
    handlerTab(item) {
      this.activeKey = item.labelId
      this.$emit('handlerTab', item)
    }
  }
}
</script>
<style lang="less" scoped>
ul::-webkit-scrollbar {
  display: none
}

.star-ul {
  width: 71px;
  height: auto;
  //max-height: 537px;
  background: linear-gradient(180deg, #F4F3F3 0%, #FAFAFA 100%);
  overflow: auto;
  border-radius: 0 0 0 6px;

  li {
    height: 48px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-top: 12px;
    position: relative;

    &:first-child {
      //margin-top: 5px;
      height: 54px;
      line-height: 58px;
      margin-top: 0;
    }

    .activeImg {
      width: 13px;
      height: 13px;
      position: absolute;
      bottom: 10px;
      right: 2px;
    }
  }

  .activeClass {
    background: #fff;
    color: #333;
    font-weight: bold;
  }


}


</style>
